import { render, staticRenderFns } from "./role-table-modal.vue?vue&type=template&id=1d669729&"
import script from "./role-table-modal.vue?vue&type=script&lang=js&"
export * from "./role-table-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports